import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesGrid from './components/ServicesGrid';
import BenefitsSection from './components/BenefitsSection';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar transparent />
      <HeroSection />
      <StatsSection />
      <ServicesGrid />
      <BenefitsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
